<p-toast [baseZIndex]="10000" key="password-forgot-message"></p-toast>

<ng-template #modalforgot let-c="close" let-d="dismiss">
  <div class="modal-header">
    <div class="modal-title" translate> Password Reset </div>
    <p-button [link]="true" type="button" class="close ml-auto no-click-styles" icon="pi pi-times" [rounded]="true" size="small" aria-label="Close" (click)="d('Cross click')" > </p-button>
  </div>
  <div class="modal-body">
    @if(isLoading || success){
      <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
    }

    <div [hidden]="isLoading || success">
      <div class="container">
        <form (ngSubmit)="sendPassword()" #passForgotForm="ngForm" >
          <div class="p-fluid grid mt-3">
            <div class="p-field mt-4 mb-2 col-12">
              <p-floatlabel>
                <label translate> Common.User </label>
                <input pInputText name="userName" #userName="ngModel" type="email" [readOnly]="true" [disabled]="true" [(ngModel)]="resetPassInfo.username" required />
              </p-floatlabel>
            </div>

            <div class="p-field mt-4 mb-2 col-12">
              <p-floatlabel>
                <label translate> Change Pass.New Password </label>
                <input pInputText name="pass" #pass="ngModel" type="password" [disabled]="isError && !existExplicitError" [(ngModel)]="resetPassInfo.password" required/>
              </p-floatlabel>
              <small *ngIf="passwordError && existExplicitError" class="text-danger" translate> {{ passwordError.description | translate:{ quantityMax: passwordError.quantityMax, quantityMin: passwordError.quantityMin } }} </small>
              <small [hidden]="existExplicitError || pass.valid || pass.untouched" class="text-danger" translate> Generic Errors.Required Password </small>
            </div>

            <div class="p-field mt-4 mb-2 col-12">
              <p-floatlabel>
                <label translate> Change Pass.New Password2 </label>
                <input pInputText name="secondPassword" #secondPassword="ngModel" type="password" [disabled]="isError && !existExplicitError" [(ngModel)]="resetPassInfo.secondpassword"  required/>
              </p-floatlabel>

              <small *ngIf="secondPasswordError && existExplicitError" class="text-danger" translate> {{ secondPasswordError.description | translate:{ quantityMax: secondPasswordError.quantityMax, quantityMin: secondPasswordError.quantityMin } }} </small>
              <small [hidden]="existExplicitError || secondPassword.valid || secondPassword.untouched" class="text-danger" translate>
                Generic Errors.Required Password Verification
              </small>
            </div>
          </div>

          <div class="mt-3 text-center">
            <p-button severity="primary" type="submit" icon="pi pi-send" label="{{ 'Send' | translate }}" [loading]="isLoading" [disabled]="passForgotForm.invalid || isLoading || isError && !existExplicitError"> </p-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>
